<template>
  <div>
    <purchases :id="order.id" :order="order"/>
    <promotions :order="order" :partner="partner"  />
    <hr />
    <h5>
      Стоимость заказа: {{ order.price_total | spaceBetweenNumber }} UZS без %
    </h5>
    <hr />
    <h5>
      Доступный лимит для покупки: {{ limit_user | spaceBetweenNumber }} UZS
    </h5>
    <br />
    <label>{{
      "select_period_credit" | setText("Выберите период рассрочки")
    }}</label>
    <select class="form-control" v-model="limit">
      <option
        v-for="(cond, index) in partner.conditionals"
        :key="index"
        :value="cond.month"
      >
        {{ cond.month }} месяцев
      </option>
    </select>
    <div v-if="validate === true">
      <div class="install-control">
        <button @click="next" class="btn btn-success">
          {{ "next_step" | setText("Далее") }}
        </button>
      </div>
    </div>
    <div v-else>
      <h3 class="text-danger">
        {{ "order_error" | setText("Заказ не проходит условию") }}
      </h3>
      <h5>
        {{ "min_price_partner" | setText(" Минимальная цена заказа") }}:
        {{ partner.min_price | spaceBetweenNumber }} UZS
      </h5>
      <h5>
        {{ "max_price_partner" | setText(" Максимальная цена заказа") }}:
        {{ partner.max_price | spaceBetweenNumber }} UZS
      </h5>
      <h5>
        {{ "min_qty_partner" | setText("Минимальное количество товаров") }}:
        {{ partner.min_amount_product | spaceBetweenNumber }} шт.
      </h5>
      <h5>
        {{ "max_qty_partner" | setText("Максимальное кличество товаров") }}:
        {{ partner.max_amount_product | spaceBetweenNumber }} шт.
      </h5>
    </div>
  </div>
</template>
<script>
import Purchases from "@/components/Item/Order/Purchases";
import Promotions from "@/components/Item/Order/Promotions";
import { logger } from "../../../plugins/functions";
export default {
  components: {
    Purchases,
    Promotions,
  },
  computed: {
    validate() {
      if (this.partner.min_amount_product > this.order.quantity_total) {
        return false;
      }

      if (this.partner.max_amount_product < this.order.quantity_total) {
        return false;
      }

      if (this.partner.max_price < this.order.price_total) {
        return false;
      }

      if (this.partner.min_price > this.order.price_total) {
        return false;
      }

      return true;
    },
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    createTransaction: {
      default: function () {},
    },
    index: {
      default: 0,
    },
    limit_user: {
      default: 0,
    },
  },
  name: "filter",
  async created() {},
  methods: {
    next() {
      this.save();
    },
    prev() {
      this.$emit("next", this.index - 1);
    },

    async getProducts() {
      let products = [];
      if (this.order && this.order.purchases) {
        for (let i = 0; i < this.order.purchases.length; i++) {
          products.push({
            price: this.order.purchases[i]["price"],
            amount: this.order.purchases[i]["quantity"],
            name: this.order.purchases[i]["name"],
            category: "1",
          });
        }
      }

      return products;
    },
    async save() {
      this.$loading(true);

      let products = await this.getProducts();

      try {
        if (!products.length) {
          alert(
            "Товары не применились или в заказе нет товаров. Попробуйте снова"
          );
          this.$store.dispatch("setLastUpdate", new Date());
          return false;
        }
      } catch (error) {}

      setTimeout(() => {
        let dataSend = {
          buyer_phone: this.order.client.phone,
          limit: this.limit,
          products: products,
        };

        logger(this.$http, {
          name: "Начал формировать запрос в #PAYMART",
          description: "Начало запроса",
          model_type: "order",
          model_id: this.order.id,
          req: JSON.stringify(dataSend),
        });

        this.$http
          .post(`${this.partner["endpoint_url"]}buyers/credit/add`, dataSend, {
            headers: {
              Authorization: `Bearer ${this.partner["api_secret_key"]}`,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data) {
              switch (response.data.status) {
                case 1:
                  this.message = "Успешно создан заказ";
                  this.createTransaction({
                    month: this.limit,
                    status: response.data.status,
                    exchange_id: response.data.paymart_client.contract_id,
                    api_result: JSON.stringify(response.data),
                  });

                  setTimeout(() => {
                    this.$emit(
                      "getContract",
                      response.data.paymart_client.contract_id
                    );
                    this.$emit("next", 9);
                  }, 1000);

                  break;
                default:
                  this.message = response.data.message
                    ? response.data.message
                    : "Пользователь не найден или еще не прошел верификацию";
                  break;
              }

              logger(this.$http, {
                name: "Начал формировать запрос в #PAYMART",
                description: this.message,
                model_type: "order",
                model_id: this.order.id,
              });

              this.$notify({
                title: "PAYMART",
                message: this.message,
                icon: "ti-save",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            }
          })
          .catch((error) => {
            logger(this.$http, {
              name: "Начал формировать запрос в #PAYMART",
              description: "Ошибка партнера #PAYMART",
              model_type: "order",
              model_id: this.order.id,
            });
            alert("Ошибка партнера");
          })
          .finally(() => {
            this.$loading(false);
          });
      }, 100);
    },
  },
  data() {
    return {
      message: "",
      limit: 12,
    };
  },
};
</script>
<style lang="scss">
</style>
